module.exports = {
  adyenClientKey: {
    test: 'test_NDQDLITYWBBKHEUB5GIUAXRGFYSA3HZO',
    live: 'live_VEGIN2CENFFB3KOY5JYFC422YYOUZLGS',
  },
};